import React from "react";
import {
  Box,
  Button,
  Container,
  Paper,
  Typography,
  Divider,
} from "@mui/material";
import { useNavigate } from "react-router-dom";

const AutoSendingIndexPage = () => {
  const navigate = useNavigate();

  const menuItems = [
    {
      title: "Set up Campaign to Customer",
      path: "/admin/outbound-message/auto-sending/customer",
    },
    {
      title: "Set up Campaign to Outlet owner",
      path: "/admin/outbound-message/auto-sending/outlet-owner",
    },
  ];

  return (
    <Container maxWidth={false} sx={{ mt: 4 }}>
      <Paper elevation={1} sx={{ width: "100%" }}>
        {menuItems.map((item, index) => (
          <React.Fragment key={item.path}>
            <Box
              sx={{
                p: 3,
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
              }}
            >
              <Typography variant="body1" fontWeight="medium">
                {item.title}
              </Typography>
              <Button
                variant="outlined"
                onClick={() => navigate(item.path)}
                sx={{
                  minWidth: 100,
                  borderColor: "primary.main",
                  color: "primary.main",
                  "&:hover": {
                    borderColor: "primary.dark",
                    backgroundColor: "rgba(25, 118, 210, 0.04)",
                  },
                }}
              >
                SELECT
              </Button>
            </Box>
            {index < menuItems.length - 1 && <Divider />}
          </React.Fragment>
        ))}
      </Paper>
    </Container>
  );
};

export default React.memo(AutoSendingIndexPage);
